// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"753":"efb443b8102cf2a5","935":"4e42d9b1123735bd"}[chunkId] + ".js";
};